export default __webpack_public_path__ + "static/media/Bb.ccc58505.wav";